@if (appInfo.settings.church !== 'neland') {
  <div class="middle-box text-center loginscreen animated fadeInDown">
    <div><h1 class="logo-name">Ark</h1></div>
    <h3>Welcome to {{ church }} Ark</h3>
    <div style="margin-top: 25px;">client version: {{ appInfo.clientVersion }}</div>
    <div style="margin-top: 5px;">service version: {{ appInfo.serviceVersion }}</div>
  </div>
}



@if (appInfo.graafschap) {
  <div style="margin-top: 100px; margin-left: 50px;">
  </div>
}
<div style="margin-top: 50px; margin-left: 50px;"><a href (click)="logout()">log out</a></div>
